import { render, staticRenderFns } from "./SetManagementButton.vue?vue&type=template&id=04d33a37"
import script from "./SetManagementButton.vue?vue&type=script&lang=ts"
export * from "./SetManagementButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports